import { createApiCall } from 'lib/base';

const LIST_STAG_PORTFOLIOS_API = 'INVESTCORE/LIST_STAG_PORTFOLIOS_API';
const GET_STAG_PORTFOLIO_API = 'INVESTCORE/GET_STAG_PORTFOLIO_API';
const CREATE_STAG_PORTFOLIO_API = 'INVESTCORE/CREATE_STAG_PORTFOLIO_API';
const UPDATE_STAG_PORTFOLIO_API = 'INVESTCORE/UPDATE_STAG_PORTFOLIO_API';
const DELETE_STAG_PORTFOLIO_API = 'INVESTCORE/DELETE_STAG_PORTFOLIO_API';

export const listStagPortfoliosApiCall = createApiCall(
  LIST_STAG_PORTFOLIOS_API,
  () => ({
    endpoint: '/api/admin/stag-portfolios',
    method: 'GET',
  })
);

export const getStagPortfolioApiCall = createApiCall(
  GET_STAG_PORTFOLIO_API,
  ({ id }) => ({
    endpoint: `/api/admin/stag-portfolios/${id}`,
    method: 'GET',
  })
);

export const createStagPortfolioApiCall = createApiCall(
  CREATE_STAG_PORTFOLIO_API,
  ({ title, description, risk_profile, ranking, items }) => ({
    endpoint: '/api/admin/stag-portfolios',
    method: 'POST',
    body: { title, description, risk_profile, ranking, items },
    notify: true,
  })
);

export const updateStagPortfolioApiCall = createApiCall(
  UPDATE_STAG_PORTFOLIO_API,
  ({ id, title, description, risk_profile, ranking, items }) => ({
    endpoint: `/api/admin/stag-portfolios/${id}`,
    method: 'PUT',
    body: { title, description, risk_profile, ranking, items },
    notify: true,
  })
);

export const deleteStagPortfolioApiCall = createApiCall(
  DELETE_STAG_PORTFOLIO_API,
  ({ id }) => ({
    endpoint: `/api/admin/stag-portfolios/${id}`,
    method: 'DELETE',
    notify: true,
  })
);

export default listStagPortfoliosApiCall;
